import { useNavigate } from "react-router-dom";

import useGetDalers, { useGetNewDalers } from "@Hooks/useDealers";

import styles from "./InformationTabs.module.scss";

function InformationTabs() {
  const navigate = useNavigate();
  const { totalDocs } = useGetDalers();
  const { totalDocs: addedThisMonth } = useGetNewDalers();

  const handleShowMap = () => navigate("/dealers/map");

  return (
    <div className={styles.infoContainer}>
      <div className={styles.infoCard}>
        <div className={styles.infoLabel}>Total count</div>
        <div className={styles.infoValue}>{totalDocs ?? 0}</div>
      </div>

      <div className={styles.infoCard}>
        <div className={styles.infoLabel}>Added this month</div>
        <div className={styles.infoValue}>{addedThisMonth ?? 0}</div>
      </div>

      <button className={styles.mapButton} onClick={handleShowMap}>
        <div className={styles.buttonText}>Show deals map</div>
      </button>
    </div>
  );
}

export default InformationTabs;
